<div [className]="activeFileCategory + '_type-of-files container-fluid py-4'">
  <div class="py-4 heading-container">
    <div class="d-inline-block align-middle me-2 mb-1">
      <img src="assets/icons/icon-files.svg" width="33" height="33" alt="" />
    </div>
    <h1 class="d-inline-block align-middle m-0">
      {{ 'MY_FILES_TITLE' | translate }}
    </h1>
  </div>
  <div class="pt-3 pb-4 d-flex justify-content-between flex-wrap">
    <div>
      <div *ngIf="!selectedItems?.length">
        <input
          hidden
          data-test-id="btn-upload-files-input"
          id="btn-upload-files-input"
          (change)="uploadFiles($event)"
          type="file"
          multiple
          #uploader
        />
        <button
          type="button"
          class="btn btn-primary mb-2 mb-sm-0"
          data-test-id="btn-upload-files-button"
          (click)="uploader.click()"
        >
          {{ 'FILE_MANAGER_UPLOAD_BTN_HINT' | translate }}
        </button>
        <div class="pt-1 text-muted">{{ 'FILE_MANAGER_MAXIMUM_FILE_SIZE_HINT' | translate }}</div>
      </div>
      <button
        *ngIf="selectedItems?.length === 1"
        type="button"
        class="btn btn-primary me-2 mb-2 mb-sm-0"
        data-test-id="btn-download-files"
        (click)="downloadFiles()"
      >
        {{ 'FILE_MANAGER_DOWNLOAD_BTN_HINT' | translate }}
      </button>
      <button
        *ngIf="selectedItems?.length === 1 && filesTabActive.allowManaging"
        type="button"
        class="btn btn-primary me-2 mb-2 mb-sm-0"
        data-test-id="btn-share-files"
        (click)="shareFiles()"
      >
        {{ 'FILE_MANAGER_SHARE_BTN_HINT' | translate }}
      </button>
      <button
        *ngIf="canShowUnshareBtn"
        type="button"
        class="btn btn-primary me-2 mb-2 mb-sm-0"
        data-test-id="btn-delete-or-share-files"
        (click)="unshareFiles()"
      >
        {{ 'FILE_MANAGER_UNSHARE_BTN_HINT' | translate }}
      </button>
      <button
        *ngIf="
          (selectedItems?.length > 0 && (filesTabActive.allowManaging || filesTabActive.allowPublic)) ||
          (isFileChangesCompleted() | async)
        "
        type="button"
        class="btn btn-primary mb-2 mb-sm-0"
        data-test-id="btn-delete-files"
        (click)="deleteFiles()"
      >
        {{ (selectedItems?.length > 1 ? 'FIELD_DELETE_FILES_HINT' : 'FILE_MANAGER_DELETE_BTN_HINT') | translate }}
      </button>
    </div>
    <div *ngIf="totalStorageSize" class="ps-2 storage-sixe-box">
      <h4 class="left-space" data-test-id="left-space">
        <b>
          {{
            'FILE_MANAGER_STORAGE_SIZE_FREE_HINT'
              | translate
                : {
                    unusedStorageSize: unusedStorageSize,
                    totalStorageSize: totalStorageSize
                  }
          }}
        </b>
      </h4>
      <div class="progress">
        <div
          class="progress-bar progress-bar-striped"
          role="progressbar"
          [style.width]="progressBarValue + '%'"
          [ngClass]="{
            'bg-success': progressBarValue <= infoValue,
            'bg-info': progressBarValue > infoValue && progressBarValue <= warningValue,
            'bg-warning': progressBarValue > warningValue && progressBarValue <= dangerValue,
            'bg-danger': progressBarValue > dangerValue
          }"
          aria-valuemin="0"
          aria-valuemax="100"
          [attr.aria-valuenow]="progressBarValue"
          data-test-id="progress-bar"
        ></div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-3 col-md-2">
      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a
          data-test-id="file-tab-documents"
          class="nav-link"
          [routerLink]="getCurrentRoute(activeTab)"
          [queryParams]="{ type: 'documents' }"
          routerLinkActive="active"
        >
          {{ 'DOCUMENTS_TAB' | translate }}
        </a>
        <a
          data-test-id="file-tab-images"
          class="nav-link"
          [routerLink]="getCurrentRoute(activeTab)"
          [queryParams]="{ type: 'images' }"
          routerLinkActive="active"
        >
          {{ 'IMAGES_TAB' | translate }}
        </a>
        <a
          data-test-id="file-tab-video"
          class="nav-link"
          [routerLink]="getCurrentRoute(activeTab)"
          [queryParams]="{ type: 'video' }"
          routerLinkActive="active"
        >
          {{ 'VIDEO_TAB' | translate }}
        </a>
        <a
          data-test-id="file-tab-audio"
          class="nav-link"
          [routerLink]="getCurrentRoute(activeTab)"
          [queryParams]="{ type: 'audio' }"
          routerLinkActive="active"
        >
          {{ 'AUDIO_TAB' | translate }}
        </a>
        <a
          data-test-id="file-tab-activities"
          class="nav-link line-top"
          [routerLink]="getCurrentRoute(activeTab)"
          [queryParams]="{ type: 'activities' }"
          routerLinkActive="active"
        >
          {{ 'ACTIVITY_TAB' | translate }}
        </a>
      </div>
    </div>
    <div class="col-sm-9 col-md-10 mt-2">
      <ng-container *ngIf="activeFileCategory !== ACTIVITIES">
        <ul
          ngbNav
          #nav="ngbNav"
          (navChange)="onTabClick($event)"
          [activeId]="activeTab"
          [destroyOnHide]="true"
          class="nav-tabs"
        >
          <li [ngbNavItem]="fileOwnershipTypes.manager">
            <a ngbNavLink [attr.data-test-id]="fileOwnershipTypes.manager">
              <div [attr.data-test-id]="'files-tab-title-' + fileOwnershipTypes.manager">
                {{ 'MY_FILES_TAB' | translate }}
              </div>
            </a>
          </li>

          <li [ngbNavItem]="fileOwnershipTypes.public">
            <a ngbNavLink [attr.data-test-id]="fileOwnershipTypes.public">
              <div [attr.data-test-id]="'files-tab-title-' + fileOwnershipTypes.manager">
                {{ 'PUBLIC_TAB' | translate }}
              </div>
            </a>
          </li>

          <li [ngbNavItem]="fileOwnershipTypes.shared">
            <a ngbNavLink [attr.data-test-id]="fileOwnershipTypes.shared">
              <div [attr.data-test-id]="'files-tab-title-' + fileOwnershipTypes.manager">
                {{ 'SHARED_WITH_ME_TAB' | translate }}
              </div>
            </a>
          </li>
        </ul>
      </ng-container>

      <dx-file-manager
        *ngIf="activeFileCategory !== ACTIVITIES"
        id="file-manager"
        [fileSystemProvider]="customFileProvider"
        [allowedFileExtensions]="allowedFileExtensions"
        [permissions]="permissions"
        [height]="fileManagerHeight"
        (onSelectedFileOpened)="displayPopup($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onContextMenuItemClick)="onMenuItemClick($event)"
        (onContentReady)="onContentReady($event)"
        (onFocusedItemChanged)="focusedItemChanges$.next($event)"
        [customizeDetailColumns]="customizeDetailColumns"
        currentPath="/"
        #fileManager
      >
        <dx-load-panel [visible]="false"> </dx-load-panel>
        <dxo-item-view [showParentFolder]="true" [contentEditable]="false">
          <dxo-details>
            <dxi-column
              [width]="screenWidth < 400 ? '210px' : screenWidth < 550 ? '45%' : '40%'"
              [hidingPriority]="4"
              dataField="name"
            ></dxi-column>
            <dxi-column
              [hidingPriority]="1"
              caption="Date Uploaded"
              sortOrder="desc"
              dataField="dateModified"
              alignment="center"
              [width]="screenWidth < 550 ? null : '20%'"
            ></dxi-column>
            <dxi-column
              [hidingPriority]="2"
              caption="Members"
              dataField="dataItem.members"
              alignment="center"
              [width]="screenWidth < 550 ? null : '20%'"
            ></dxi-column>
            <dxi-column
              [hidingPriority]="3"
              dataField="size"
              alignment="center"
              [width]="screenWidth < 550 ? '25vw' : '20%'"
            ></dxi-column>
            <dxi-column
              caption="key"
              dataField="key"
              [visible]="false"
              cssClass="file-manager__column-key"
              alignment="center"
            ></dxi-column>
          </dxo-details>
        </dxo-item-view>
        <dxo-context-menu #contextMenu>
          <dxi-item [name]="actions.DOWNLOAD"
            ><span [attr.data-test-id]="'files-menu-' + actions.DOWNLOAD">{{
              'FILE_MANAGER_DOWNLOAD' | translate
            }}</span></dxi-item
          >
          <dxi-item *ngIf="selectedItems?.length === 1 && filesTabActive.allowManaging" [name]="actions.SHARE"
            ><span [attr.data-test-id]="'files-menu-' + actions.SHARE">{{
              'FILE_MANAGER_SHARE' | translate
            }}</span></dxi-item
          >
          <dxi-item *ngIf="canShowUnshareBtn" [name]="actions.UNSHARED"
            ><span [attr.data-test-id]="'files-menu-' + actions.UNSHARED">{{
              'FILE_MANAGER_UNSHARE' | translate
            }}</span></dxi-item
          >
          <dxi-item *ngIf="filesTabActive.allowManaging || filesTabActive.allowPublic" [name]="actions.DELETE"
            ><span [attr.data-test-id]="'files-menu-' + actions.DELETE">{{
              'FILE_MANAGER_DELETE' | translate
            }}</span></dxi-item
          >
          <dxi-item
            *ngIf="filesTabActive.allowManaging || filesTabActive.allowSharing || canShowUnshareBtn"
            [name]="actions.ACTIVITIES"
            ><span [attr.data-test-id]="'files-menu-' + actions.ACTIVITIES">{{
              'FILE_MANAGER_ACTIVITY' | translate
            }}</span></dxi-item
          >
        </dxo-context-menu>
      </dx-file-manager>

      <app-activities-log *ngIf="activeFileCategory === ACTIVITIES"> </app-activities-log>
    </div>
  </div>
</div>

<app-dev-popup
  [titleToDisplay]="titleToDisplay"
  [popupVisible]="popupVisible"
  [protectedPublicURL]="protectedPublicURL"
  [popupPublicURL]="popupPublicURL"
  [contentType]="typeOfContent"
  (hiding)="hidePopup()"
></app-dev-popup>

<dx-load-panel
  #loadPanel
  [position]="{ of: '#file-manager' }"
  [visible]="!isCompleted"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
>
</dx-load-panel>
